export enum CurpStatus {
  SUCCESS = 'SUCCESS',
  UNAVAILABLE = 'UNAVAILABLE',
  FAILED = 'FAILED',
  DENIED = 'DENIED',
  DISABLED = 'DISABLED'
}

export interface ICurpResponse {
  attempts: number;
  curp: string;
  reference: string;
  status: CurpStatus;
}